var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94048e-08 5.40093C-0.000122982 4.68329 0.142796 3.97284 0.420403 3.31107C0.69801 2.64931 1.10474 2.04952 1.61681 1.54675C2.12889 1.04399 2.73604 0.648335 3.40279 0.382916C4.06953 0.117496 4.78249 -0.0123634 5.5 0.000926073C6.34896 -0.00358242 7.18919 0.172396 7.96499 0.517197C8.74079 0.861998 9.43445 1.36775 10 2.00093C10.5655 1.36775 11.2592 0.861998 12.035 0.517197C12.8108 0.172396 13.651 -0.00358242 14.5 0.000926073C15.2175 -0.0123634 15.9305 0.117496 16.5972 0.382916C17.264 0.648335 17.8711 1.04399 18.3832 1.54675C18.8953 2.04952 19.302 2.64931 19.5796 3.31107C19.8572 3.97284 20.0001 4.68329 20 5.40093C20 10.7569 13.621 14.8009 10 18.0009C6.387 14.7739 7.94048e-08 10.7609 7.94048e-08 5.40093Z",
    fill: "#D1A080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.00e0cb1b7d7fb64bfc194b376ecca1a5.svg";
export { ForwardRef as ReactComponent };